import ZalesFooter from "./zales"
import React from "react";

class PeoplesJewelersFooter extends ZalesFooter {
    siteDomain = 'PEOPLESJEWELLERS.COM'

    getSocialIcons() {
        return (
            <ul style={this.styleHidden} className="social no-padding">
                <li>
                    <a href="https://www.facebook.com/Peoples">
                        <img
                            alt="View Peoples Jewellers on Facebook"
                            src="/img/social_icons/facebook.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
                <li>
                    <a href="https://twitter.com/PeoplesDiamonds">
                        <img
                            alt="View Peoples Jewellers on Twitter" src="/img/social_icons/twitter.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
                <li>
                    <a href="https://www.pinterest.com/peoplesjewellers/">
                        <img
                            alt="View Peoples Jewellers on Pinterest"
                            src="/img/social_icons/pinterest.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/peoplesjewellers/">
                        <img
                            alt="View Peoples Jewellers on Instagram" src="/img/social_icons/insta.png"
                            style={{display: 'inline'}}/>
                    </a>
                </li>
            </ul>
        )
    }

}

export default PeoplesJewelersFooter



// WEBPACK FOOTER //
// ./src/site_interfaces/footers/peoplesjewelers.js